export const DEFAULT_PAGE_TITLE = 'EduSmart'

const getPageTitle = (pageTitle: string[]) =>
  [...pageTitle, DEFAULT_PAGE_TITLE].join(' - ')

export const getMetaWithPageTitle = (pageTitle: string[]) => ({
  meta: [
    {
      title: getPageTitle(pageTitle)
    }
  ]
})
